import axios from 'axios';
import React, { useState, useEffect } from 'react';
import constants from '../../constants'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Loading from '../../components/loading/Loading'
import potion from '../../assets/icons/potions/potion.svg'
import salve from '../../assets/icons/potions/salve.svg'
import './Potions.css'

import toast from 'react-hot-toast';

export default function Potions() {
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState([]);

    useEffect(() => {
        const splitUrl = window.location.href.split('/')
        if (splitUrl.length > 4 && items.length === 0) {
            setLoading(true)
            axios.post(constants.baseUrl + '/api/searchPotions?searchTerm=' + splitUrl[4]).then(({ data }) => {
                setItems(data);
                setLoading(false)
            })
        } else if (items.length === 0) {
            axios.post(constants.baseUrl + '/api/getRandomPotions?numberOfItems=10').then(({ data }) => {
                setItems(data);
                setLoading(false)
            })
        }
    }, [loading]);

    function refreshItems(event, rarity = null) {
        setLoading(true)
        axios.post(constants.baseUrl + '/api/getRandomPotions?numberOfItems=10' + (rarity ? '&rarity=' + rarity : '')).then(({ data }) => {
            setItems(data);
            setLoading(false)
        })
    }

    function getPotions(event) {
        setLoading(true)
        axios.post(constants.baseUrl + '/api/searchPotions?searchTerm=' + event.target.value).then(({ data }) => {
            setItems(data);
            setLoading(false)
        })
    }

    function copyToClipboard(event, potion) {
        event.stopPropagation()

        navigator.clipboard.writeText(`${potion.name} w/ ${potion.swigs} ${potion.isSalve ? 'application' : 'swig'}${potion.swigs > 1 ? 's' : ''} : ${potion.effect} (${potion.price} sc)`);
        toast.success(`The ${potion.name} has been copied`)
    }

    return (
        <div>
            {loading && <Loading />}
            {!loading && (
                <div>
                    <div className='input-shell'>
                        <div>
                            <input onBlur={getPotions}></input>
                            <p>Search Potions & Salves</p>
                        </div>
                        <div>
                            <button onClick={e => refreshItems(e, 'Common')} className='secondary' >Common</button>
                            <button onClick={e => refreshItems(e, 'Uncommon')} className='secondary' >Uncommon</button>
                            <button onClick={e => refreshItems(e, 'Rare')} className='secondary' >Rare</button>
                            <button onClick={_ => refreshItems()} >Any</button>
                        </div>
                    </div>
                    <div className='accordion-shell'>
                        {items.map((item, i) => {
                            return (
                                <Accordion key={i}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography component={'span'} variant={'body2'}>
                                            <div className='potion-shell'>
                                                <img src={item.isSalve ? salve : potion} height="50" />
                                                <div>
                                                    <div className='item-title-shell'>
                                                        <h2>{item.name}</h2>
                                                        <p>w/ {item.swigs} {item.isSalve ? 'application' : 'swig'}{item.swigs > 1 ? 's' : ''}</p>
                                                    </div>
                                                    <div>
                                                        {item.effect} <i onClick={e => copyToClipboard(e, item)} className="fa-solid fa-copy"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography component={'span'} variant={'body2'}>
                                            <div>
                                                <p>{item.typeTooltip}</p>
                                                <p className='bottom-margin'>{item.generalTooltip}</p>
                                                <div className='item-detail'><h3>Price</h3> <p>{item.price} sc</p></div>
                                                <div className='item-detail'><h3>Rarity</h3> <p>{item.rarity}</p></div>
                                                <a href={'/ingredients/' + item.name.replace('Salve', 'Potion')} target='_blank' className='potion-ingredients'>
                                                    <div className='item-detail'>
                                                        <h3>Ingredients</h3>
                                                        <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                                    </div>
                                                </a>
                                                <ul>
                                                    {item.ingredients?.map(ingredient => <li>{ingredient.ingredientName}</li>)}
                                                </ul>
                                            </div>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            )
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}